export default class ExpressRejectionList {
    shipment: string;
    reMark: string;
    rejectionTime?: Date;
    createTime: Date;
    id: number;
    warehouseInfoId: number;
    expressCompany: string;
    handleType: number;
    handleStatus: number;
    warehouseName: string;
    revokedTime?: Date;
    userId: string;
    tenantId: number;
    rejectionHandler: string;
    returnHandler: string;
    returnNo: number;
    returnExpressCompany: string;
    recipientInfo: string;
    returnTime?: Date;
    expressCost: number
}